import { GridCellParams } from '@mui/x-data-grid';

export const renderDatagridID = (params: GridCellParams) =>
  params?.row?.externalId?.trim() !== '' ? params?.row?.externalId?.trim() : params?.row?.id;

export const renderID = (params: { id?: number; externalId?: string }) =>
  params?.externalId?.trim() !== '' ? params?.externalId?.trim() : params?.id ?? '';

export const formatSiteExternalId = (externalId?: string) =>
  externalId?.trim() !== '' ? externalId?.trim().split('_')[0] : '';